import {
  POST_GENERATE_CHARGE_BEGIN, POST_GENERATE_CHARGE_SUCCESS, POST_GENERATE_CHARGE_FAILURE, CLEAR_CHARGE_INFO, INSERT_INTO_CHARGE_CREATION, GET_ISS_TAX_BEGIN, GET_ISS_TAX_SUCCESS, GET_ISS_TAX_FAILURE, PUT_ISS_TAX_FAILURE, PUT_ISS_TAX_SUCCESS, PUT_ISS_TAX_BEGIN
} from './../constants/ActionTypes'

const initialState = {
  chargeCreation: {
    amount: 1.99,
    paymentMethod: 'UNDEFINED'
  },

  loading: false,
  error: null,
  charge: null,

  loadingGetIssTax: false,
  errorGetIssTax: null,
  issTax: null
}

const ReducerFinancial = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_ISS_TAX_BEGIN: {
      return {
        ...state, 
        loadingGetIssTax: true,
        errorGetIssTax: null,
        issTax: null
      }
    }

    case GET_ISS_TAX_SUCCESS: {
      return {
        ...state, 
        loadingGetIssTax: false,
        errorGetIssTax: null,
        issTax: parseFloat(payload.response.issTax)
      }
    }

    case GET_ISS_TAX_FAILURE: {
      return {
        ...state, 
        loadingGetIssTax: false,
        errorGetIssTax: payload,
        issTax: null
      }
    }

    case PUT_ISS_TAX_BEGIN: {
      return {
        ...state, 
        loadingPutIssTax: true,
        errorPutIssTax: null,
        issTax: null
      }
    }

    case PUT_ISS_TAX_SUCCESS: {
      return {
        ...state, 
        loadingPutIssTax: false,
        errorPutIssTax: null
      }
    }

    case PUT_ISS_TAX_FAILURE: {
      return {
        ...state, 
        loadingPutIssTax: false,
        errorPutIssTax: payload
      }
    }

    case INSERT_INTO_CHARGE_CREATION: {
      return {
        ...state,
        chargeCreation: {
          ...state.chargeCreation,
          ...payload
        }
      }
    }

    case POST_GENERATE_CHARGE_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null,
        charge: null
      }
    }
    case POST_GENERATE_CHARGE_SUCCESS: {

      return {
        ...state,
        loading: false,
        error: null,
        charge: payload.response
      }
    }
    case POST_GENERATE_CHARGE_FAILURE: {
      return {
        ...state,
        loading: false,
        error: payload,
        charge: null
      }
    }

    case CLEAR_CHARGE_INFO: {
      return initialState
    }

    default: return state
  }
}

export default ReducerFinancial